/* ==========================================================================
   STORMROCK — feuille de choix du format, mobile.

   Portée : les cartes produit de la page collection ET, depuis le
   19/09/2026, celles du carrousel « Tu vas aussi kiffer… » de la fiche
   produit (demandé par Fabien : même format des deux côtés). Le CSS de
   l'état fermé vit dans sr-fmt-sheet.css pour la collection et dans
   sr-fmt-reco.css pour le carrousel.

   Le fieldset est DÉPLACÉ dans un conteneur accroché à <body> pendant
   l'ouverture, puis remis exactement à sa place à la fermeture. C'est
   nécessaire : un ancêtre de la carte crée un bloc conteneur (transform /
   contain), donc un position:fixed posé sur le fieldset reste enfermé dans
   la colonne de la carte.
   ========================================================================== */
(function () {
  'use strict';

  var MQ = '(max-width: 749px)';
  var fs = null;      // fieldset ouvert
  var place = null;   // marqueur de sa position d'origine
  var sheet = null;
  var dim = null;

  function mobile() { return window.matchMedia(MQ).matches; }

  function cible(e) {
    if (!e.target || !e.target.closest) return null;
    var lab = e.target.closest('.variant-option__button-label');
    if (!lab) return null;
    var f = lab.closest('fieldset.variant-option--buttons');
    if (!f) return null;
    /* 19/09/2026 : le carrousel de recommandations rejoint la collection.
       Condition d'origine, pour revenir en arrière :
         !(f.closest('.collection-wrapper') && f.closest('.product-card')) */
    var zone = f.closest('.collection-wrapper') || f.closest('.product-recommendations');
    if (!f.closest('.sr-fmt-sheet') && !(zone && f.closest('.product-card'))) return null;
    return { label: lab, fieldset: f };
  }

  function titre(f) {
    var carte = f.closest('.product-card');
    if (!carte) return 'Choisis ton format';
    var liens = carte.querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < liens.length; i++) {
      var t = (liens[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (t.length > 1) return t;
    }
    return 'Choisis ton format';
  }

  function nombre(txt) {
    var v = parseFloat((txt || '').replace(/[^0-9.,]/g, '').replace(',', '.'));
    return isFinite(v) ? v : 0;
  }

  /* remise relative au plus petit format, calculée sur le prix au gramme */
  function remises(f) {
    var labs = f.querySelectorAll('.variant-option__button-label');
    var ref = 0;
    for (var i = 0; i < labs.length; i++) {
      var pg = labs[i].querySelector('.variant-option__price-per-gram');
      var v = pg ? nombre(pg.textContent) : 0;
      if (i === 0) ref = v;
      var vieux = labs[i].querySelector('.sr-fmt-sv');
      if (vieux) vieux.remove();
      var sv = document.createElement('span');
      sv.className = 'sr-fmt-sv';
      if (ref > 0 && v > 0 && v < ref) {
        sv.textContent = '−' + Math.round((1 - v / ref) * 100) + ' %';
      }
      var txt = labs[i].querySelector('.variant-option__button-label__text');
      var tot = labs[i].querySelector('.variant-option__total');
      if (txt) { tot ? txt.insertBefore(sv, tot) : txt.appendChild(sv); }
    }
  }

  function entete(f, nom) {
    var lg = f.querySelector('legend');
    if (!lg) return;
    lg.innerHTML = '';
    var t = document.createElement('span');
    t.className = 'sr-fmt-t';
    t.textContent = nom;
    var x = document.createElement('span');
    x.className = 'sr-fmt-x';
    x.textContent = '✕';
    lg.appendChild(t);
    lg.appendChild(x);
  }

  function ouvrir(f) {
    if (fs) fermer();
    var nom = titre(f);

    place = document.createComment('sr-fmt');
    f.parentNode.insertBefore(place, f);

    dim = document.createElement('div');
    dim.className = 'sr-fmt-dim';
    sheet = document.createElement('div');
    sheet.className = 'sr-fmt-sheet';

    document.body.appendChild(dim);
    document.body.appendChild(sheet);
    sheet.appendChild(f);

    entete(f, nom);
    remises(f);

    document.body.classList.add('sr-fmt-lock');
    fs = f;
  }

  function fermer() {
    if (fs && place && place.parentNode) {
      try { place.parentNode.insertBefore(fs, place); } catch (err) {}
    }
    if (place && place.parentNode) place.parentNode.removeChild(place);
    if (sheet) sheet.remove();
    if (dim) dim.remove();
    fs = null; place = null; sheet = null; dim = null;
    document.body.classList.remove('sr-fmt-lock');
  }

  /* capture : on décide AVANT que le thème ne traite le clic */
  document.addEventListener('click', function (e) {
    if (!mobile()) { if (fs) fermer(); return; }

    if (fs && (e.target === dim || (e.target.classList && e.target.classList.contains('sr-fmt-x'))
               || (e.target.closest && e.target.closest('.sr-fmt-x')))) {
      e.preventDefault(); e.stopPropagation(); fermer(); return;
    }

    var c = cible(e);
    if (!c) { if (fs) fermer(); return; }

    if (!fs) {                     /* menu fermé -> on ouvre la feuille */
      e.preventDefault();
      e.stopPropagation();
      ouvrir(c.fieldset);
      return;
    }
    /* feuille ouverte : on remet le fieldset en place TOUT DE SUITE, puis on
       laisse le clic suivre son cours et le thème changer de variante. */
    if (c.fieldset === fs) fermer();
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && fs) fermer();
  });

  window.addEventListener('resize', function () { if (fs && !mobile()) fermer(); });
})();